import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import _ from 'lodash';

interface Errors {
  email?: string;
  password?: string;
}
export default function validateInput(
  data,
): {
    checkErrors: Errors;
    checkIsValid: boolean;
  } {
  const checkErrors: Errors = {};

  if (data.email === '') {
    checkErrors.email = 'This field is required';
  }
  if (data.email === null) {
    checkErrors.email = 'This field is required';
  }
  if (data.password === null) {
    checkErrors.password = 'This field is required';
  }

  if (!isEmpty(checkErrors)) {
    return {
      checkErrors,
      checkIsValid: isEmpty(checkErrors),
    };
  }

  if (Validator.isEmpty(data.email)) {
    checkErrors.email = 'This field is required';
  }
  if (!Validator.isEmail(_.trim(_.toLower(data.email)))) {
    checkErrors.email = `${_.trim(_.toLower(data.email))} is not a valid email`;
  }
  if (Validator.isEmpty(data.password)) {
    checkErrors.password = 'This field is required';
  }

  return {
    checkErrors,
    checkIsValid: isEmpty(checkErrors),
  };
}
